// @ts-check

import React from "react";
import { Tooltip } from "primereact/tooltip";
import "./IndicatorCell.css";

/**
 * IndicatorCell component
 *
 * This component renders a collection of indicators for each specified field in the row data.
 * Each indicator is highlighted if the corresponding field value in the row data is truthy.
 *
 * @param {Object} props - The component props.
 * @param {Record<string, string | undefined | null>} props.rowData - An object containing the data for a row, where keys are field names.
 * @param {string[]} props.fields - An array of field names to be displayed as indicators.
 * @param {Object} props.tooltipContent - An object of field names mapped with the required tooltip content
 *
 * @returns {JSX.Element} The rendered indicators for the specified fields in the row data.
 */
export function IndicatorCell({ rowData, fields, tooltipContent = null }) {
  return (
    <div className="indicators">
      {fields.map((field) => {
        const indicatorField = rowData[field];
        return (
          <>
            <div
              className="indicator"
              key={field}
              data-pr-position="right"
              data-pr-at="right+5 top"
              data-pr-my="left center-2"
              id={`indicator-${field}`}
            >
              <span className={indicatorField ? "highlight" : ""}>
                {indicatorField}
              </span>
            </div>
            {indicatorField && tooltipContent && (
              <Tooltip
                content={tooltipContent[field]}
                target={`#indicator-${field}`}
              />
            )}
          </>
        );
      })}
    </div>
  );
}
